import { CATEGORIES_FIND_MANY } from '../lib/endpoints/category';
import axios from '../lib/axios';
import { CategoryModel } from '../models/categoryCopy';

export const getCategoriesByMerchantId = async ({
  merchantId,
}: {
  merchantId: string;
}): Promise<CategoryModel[]> => {
  const resData = await axios.post(CATEGORIES_FIND_MANY, { filter: { merchant_id: merchantId } });
  return resData?.data?.data;
};
